//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpAlarmGroup } from "../models/core"
import { ColumnInfo } from "../models/custom"


export class DataProviderAlarmGroup {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion

    public getAlarmGroupFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpAlarmGroup>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdAlarmGroup, 'OpxAlarmGroupFilter', 'OpxAlarmGroupFilterResult')
    }

    //#region Get

    public getAlarmGroup = (id: number): JQueryPromise<OpAlarmGroup> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetAlarmGroup', { IdAlarmGroup: id }, 'OpxGetAlarmGroupResult')
            .then((result: any) => {
                if (result != null) {
                    const alarmGroup: OpAlarmGroup = new OpAlarmGroup(result)

                    return OpAlarmGroup
                        .loadNavigationProperties(this.dataProvider, [alarmGroup])
                        .then((alarmGroups: OpAlarmGroup[]) => {
                            return _.first(alarmGroups)
                        })
                }
                return null
            })
    }

    //#endregion

    //#region Save

    public saveAlarmGroup = (opObj: OpAlarmGroup): JQueryPromise<OpAlarmGroup> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveAlarmGroup', { ToBeSaved: opObj.toJSON() }, 'OpxSaveAlarmGroupResult')
            .then((result: any) => {
                if (result != null) {
                    const alarmGroup: OpAlarmGroup = new OpAlarmGroup(result)

                    return OpAlarmGroup
                        .loadNavigationProperties(this.dataProvider, [alarmGroup])
                        .then((alarmGroups: OpAlarmGroup[]) => {
                            return _.first(alarmGroups)
                        })
                }

                return null
            })
    }

    //#endregion

    //#region Delete

    public deleteAlarmGroup = (opObj: OpAlarmGroup): JQueryPromise<OpAlarmGroup> => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteAlarmGroup', { ToBeDeleted: opObj.toJSON() }, null)
    }

    //#endregion
}